import { useEffect } from 'react';
import JsonViewer from 'src/shared/components/typography/JsonViewer';
import { useErrorLogger } from 'src/shared/queries/utils/useErrorLogger';
import { Entities } from 'src/features/messages/types/message.types';
import { ErrorComponent } from 'src/shared/types/util.types';

type EntityTreeErrorFallbackProps = ErrorComponent & {
  entities: Entities[string];
  onError: () => void;
};

export default function EntityTreeErrorFallback({ error, entities, onError }: EntityTreeErrorFallbackProps) {
  const { reportCrash } = useErrorLogger();

  useEffect(() => {
    reportCrash(error, {
      title: 'Entity Tree Crashed ⚠️',
      message: error.message,
      component: 'EntityTree',
    });
    onError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {/* <EmptyStateCard title="Something went wrong" description="Please try again later" />{' '} */}
      <div className="w-full border bg-white rounded-sm px-2">
        <JsonViewer>{entities}</JsonViewer>
      </div>
    </div>
  );
}
